import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 📜 Remonte automatiquement en haut de page à chaque changement de route.
 * React Router ne le fait pas tout seul : sans ce composant, naviguer
 * vers une nouvelle page garde le scroll là où on était sur la page
 * précédente — d'où l'effet "toujours en bas" en entrant sur une page.
 *
 * Ce composant ne rend rien à l'écran (`return null`), il vit juste dans
 * l'arbre React pour observer les changements d'URL.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;